import { defineFeature } from "../../app/feature";
import { EngagementTemplatesPage } from "./EngagementTemplatesPage";
import { IntakeWizardPage } from "./IntakeWizardPage";
import { ReviewCapacityPage } from "./ReviewCapacityPage";

/** Engagement setup from templates (DESIGN-SPEC 28.2; task 4170.1). Owned by the
 * consultant-ops lane. Read-only roles may browse the catalog; creating an engagement is still
 * authorized by the API (engagement.manage). */
export default defineFeature({
  id: "engagements",
  title: "Engagement templates",
  routes: [
    { path: "/engagements", Component: EngagementTemplatesPage },
    { path: "/engagements/:engagementId/intake", Component: IntakeWizardPage },
    { path: "/engagements/review-capacity", Component: ReviewCapacityPage },
  ],
  nav: { label: "New engagement", path: "/engagements", section: "Engagements", order: 10 },
  permissions: ["engagement.manage", "engagement.read"],
});
